import { createContext, useContext, useMemo, useState } from "react";

const defaultValues = {
  projectData: [],
  setProjectData: () => {},
  availableTimeBlocks: [],
  setAvailableTimeBlocks: () => {},
};
export const EngagementContext = createContext(defaultValues);

/**
 * Wrapper component for User Engagement context provider
 * @author Bhavana
 */
export const EngagementContextProvider = ({ children }) => {
  const [projectData, setProjectData] = useState(defaultValues.projectData);
  const [availableTimeBlocks, setAvailableTimeBlocks] = useState(defaultValues.availableTimeBlocks);

  const value = useMemo(
    () => ({
      projectData,
      setProjectData,
      availableTimeBlocks,
      setAvailableTimeBlocks,
    }),
    [projectData, availableTimeBlocks],
  );

  return <EngagementContext.Provider value={value}>{children}</EngagementContext.Provider>;
};

// Custom hook to use the EngagementContext
export const useEngagementContext = () => {
  return useContext(EngagementContext);
};
